import React, { useMemo } from 'react'
import { TabSwitch } from 'components'

const PROFILE_VIEW_TYPE = {
  listView: 'List view',
  singleView: 'Single view',
}

const SwitchForViewType = ({ onFilter, viewType }) => {
  const filters = useMemo(
    () =>
      Object.values(PROFILE_VIEW_TYPE).map(status => ({
        label: status,
        key: status,
        isActive: status === viewType,
        width: 40,
      })),
    [viewType]
  )

  return (
    <div className="absolute flex left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
      <TabSwitch
        buttonClassName={`w-40`}
        tabs={filters}
        onChange={filter => onFilter(filter.key)}
      />
    </div>
  )
}

export default SwitchForViewType
